var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vs-button',{attrs:{"disabled":_vm.disabled,"color":"primary","type":"filled"},on:{"click":function($event){return _vm.createPDF()}}},[_vm._v("\n    Download PDF\n  ")]),_c('pdfExportTemplate')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }